export default "__VITE_ASSET__CbDeUOd0__"